module.exports = __webpack_public_path__ + "static/media/Angle's Class II Division II13.ef2234f3.png";